import { loginEventDetect } from './loginEvent';
import { logoutEventDetect } from './logoutEvent';
export var detectUser = function detectUser(props) {
  var accountIdentifier = props.accountIdentifier,
      isUserLoggin = props.isUserLoggin,
      loyalty = props.loyalty;

  if (isUserLoggin) {
    loginEventDetect((loyalty === null || loyalty === void 0 ? void 0 : loyalty.ExternalCustomerId) || '');
  } else {
    logoutEventDetect();
  }

  var event = {
    event: 'detect_user',
    detailed_event: 'Detect User',
    page_data: {
      user_login_state: isUserLoggin ? 'Authenticated' : 'Unauthenticated'
    },
    user_data: {
      loyalty_user_id: (loyalty === null || loyalty === void 0 ? void 0 : loyalty.ExternalCustomerId) ? loyalty.ExternalCustomerId : '',
      ga_user_id: accountIdentifier ? accountIdentifier : '',
      user_type: isUserLoggin ? 'user' : 'guest',
      balance: (loyalty === null || loyalty === void 0 ? void 0 : loyalty.Balance) ? loyalty.Balance : '',
      enroll_date: (loyalty === null || loyalty === void 0 ? void 0 : loyalty.EnrolledAt) ? loyalty.EnrolledAt : '',
      kibo_user_id: '',
      azure_user_id: ''
    }
  };
  return event;
};